import { type ActionArgs } from 'xstate5';

import { type LockOrderReason } from '@sg/graphql-schema';

import { type OrderingContext } from './ordering-machine.context';
import { type OrderingEvent } from './ordering-machine.events';

export type OrderingMachineAction<ActionParams extends Record<string, unknown> | void = void> = (
  actionArgs: ActionArgs<OrderingContext, OrderingEvent, OrderingEvent>,
  params: ActionParams,
) => void;

// ─────────────────────────────────────────────────────────────────────────────

export type LeaveGroupOrderErrorParams = {
  errorMessage: string | undefined;
  isHost: boolean;
};

export type GroupOrderLockReasonParams = {
  reason: LockOrderReason;
};

export type LockGroupOrderErrorParams = {
  errorMessage: string | undefined;
};

export type ConvertToGroupOrderErrorParams = {
  errorMessage: string | undefined;
};
